var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingTourUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4749_13217)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9914 4.51682C13.4795 4.02266 11.8533 4.84769 11.3592 6.35956L5.99067 22.7845C5.49651 24.2963 6.32153 25.9225 7.83341 26.4167L18.7833 29.9957C20.2952 30.4899 21.9214 29.6648 22.4156 28.153L26.2566 16.4012C26.4939 15.6752 26.4331 14.8846 26.0875 14.2035L22.9418 8.00285C22.5962 7.32168 21.9942 6.80568 21.2682 6.56838L14.9914 4.51682Z",
    fill: "#FA532E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0983 22.731C14.3423 22.4839 13.9298 21.6708 14.1769 20.9149L15.7811 16.0069L13.433 17.1981C12.7238 17.5579 11.8572 17.2747 11.4974 16.5654C11.1375 15.8562 11.4208 14.9895 12.13 14.6297L17.5784 11.8656C18.2876 11.5058 19.1543 11.7891 19.5141 12.4983L22.2782 17.9467C22.638 18.6559 22.3547 19.5225 21.6455 19.8824C20.9363 20.2422 20.0696 19.9589 19.7098 19.2497L18.5186 16.9016L16.9144 21.8096C16.6673 22.5656 15.8542 22.9781 15.0983 22.731Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4749_13217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.648,
    height: 27.648,
    fill: "white",
    transform: "translate(8.58984) rotate(18.1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingTourUpload);
export default __webpack_public_path__ + "static/media/onboarding-tour-upload.5fa034899f583ae5dca1694caed0c6f1.svg";
export { ForwardRef as ReactComponent };